module.exports = __webpack_public_path__ + "img/gps-disabled.37b67b26.png";